import { render } from "./SingleProject.vue?vue&type=template&id=d90de1aa"
import script from "./SingleProject.vue?vue&type=script&lang=js"
export * from "./SingleProject.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrien/perso/Projets/new-portfolio/vuejs-tailwind-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__